<template>
  <div class="layout-page">
    <header class="header">
      <TopNav />
    </header>
    <section class="contaniner">
      <div class="sidebar-wrapper">
        <MenuList :menu-list="financMenuList" />
      </div>
      <div class="right-content">
        <router-view />
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import TopNav from "@/components/TopNav";
import MenuList from "@/views/workbench/components/menuList";
import Footer from "@/components/Footer";
export default {
  name: "financInstitutionLayout",
  components: { TopNav, MenuList, Footer },
  data() {
    return {
      financMenuList: [
        { name: "工作台", index: "staging" },
        {
          name: "我的产品",
          index: "myProduct",
          children: [
            { name: "我的金融产品", index: "publishProduct" },
            { name: "我的放贷交易", index: "lendingTransactions" },
          ],
        },
        {
          name: "我的客户",
          index: "myCustomer",
          children: [{ name: "企业信用查询", index: "creditQuery" }],
        },
        {
          name: "金融机构信息",
          index: "institutionInfo",
          children: [
            { name: "基本信息", index: "baseInfo" },
            { name: "机构认证", index: "certificateAuthority" },
          ],
        },
        { name: "我的消息", index: "jrjgMessage" },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.layout-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #eef2f8 0%, #dce8f8 100%);
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.contaniner {
    width: 100%;
    display: flex;
    justify-content: center;
  min-height: 100vh;
  padding-top: 80px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #EBF3FE 30%, #BADBFE 60%), linear-gradient(to right, #ACD6FC, #BADBFE, #BFD9FE, #CDCEFC);
}

.sidebar-wrapper {
   width: 200px;
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: 100px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;

  ::v-deep .page-left {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .menuBox {
    flex: 1;
  }
}

.right-content {
  flex: 1;
  max-width: 1280px;
  padding-top: 20px;
  padding-bottom: 100px;
}
</style>
